(function () {
	const initSliders = () => {
		$(".tabs-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return;
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".tabs");
			const autoplay = box.data("autoplay");
			const delay = box.data("delay") * 1000;

			const baseSwiperParams = () => ({
				effect: box.data("effect"),
				speed: box.data("speed") * 1000,
				slidesPerView: 1,
				autoHeight: false,
				keyboard: true,
				loop: true,
				watchSlidesProgress: true,
				allowTouchMove: false,
			});

			const mainSwiper = new Swiper(`#${id} .tabs_box`, {
				...baseSwiperParams(),
				autoplay: autoplay
					? {
							delay: delay,
							disableOnInteraction: false,
					  }
					: false,
			});

			let secondSwiper;
			const secondSwiperElement = $(this).find(".tabs_box-content");
			if (secondSwiperElement.length > 0) {
				secondSwiper = new Swiper(`#${id} .tabs_box-content`, {
					...baseSwiperParams(),
					autoplay: false,
				});

				mainSwiper.on("slideChange", function () {
					const targetIndex = mainSwiper.realIndex;
					secondSwiper.slideToLoop
						? secondSwiper.slideToLoop(targetIndex)
						: secondSwiper.slideTo(targetIndex);
				});

				secondSwiper.on("slideChange", function () {
					const targetIndex = secondSwiper.realIndex;
					mainSwiper.slideToLoop
						? mainSwiper.slideToLoop(targetIndex)
						: mainSwiper.slideTo(targetIndex);
				});
			}

			const sliderThumbs = new Swiper(`#${id} .tabs-thumb_wrapper`, {
				spaceBetween: 16,
				slidesPerView:
					$(this).find(".tabs_wrapper-type3").length > 0
						? box.data("per-row")
						: 1.4,
				speed: box.data("speed") * 1000,
				freeMode: false,
				allowTouchMove: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				watchOverflow: true,
				loop: false,
				breakpoints: {
					576: {
						slidesPerView:
							$(this).find(".tabs_wrapper-type3").length > 0
								? box.data("per-row")
								: 2.2,
					},
					990: {
						slidesPerView: box.data("per-row"),
						allowTouchMove: false,
					},
				},
			});

			function setActiveThumb(targetIndex) {
				sliderThumbs.slides.forEach((slide, index) => {
					slide.classList.toggle("active", index === targetIndex);
				});
			}

			mainSwiper.on("slideChange", function () {
				const activeIndex = mainSwiper.realIndex;
				setActiveThumb(activeIndex);
				sliderThumbs.slideTo(activeIndex);
				if (secondSwiper) {
					secondSwiper.slideToLoop
						? secondSwiper.slideToLoop(activeIndex)
						: secondSwiper.slideTo(activeIndex);
				}
			});

			sliderThumbs.on("click", function () {
				const clickedIndex = sliderThumbs.clickedIndex;
				if (clickedIndex != null) {
					const targetIndex = clickedIndex;
					mainSwiper.slideToLoop
						? mainSwiper.slideToLoop(targetIndex)
						: mainSwiper.slideTo(targetIndex);
					sliderThumbs.slideTo(targetIndex);
					if (secondSwiper) {
						secondSwiper.slideToLoop
							? secondSwiper.slideToLoop(targetIndex)
							: secondSwiper.slideTo(targetIndex);
					}
				}
			});

			if (sliderThumbs.slides.length) {
				sliderThumbs.slides[0].classList.add("active");
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		initSliders();
		document.addEventListener("shopify:section:load", function () {
			initSliders();
		});
	});
})();
